(function(global) {
    var menuOpened = false,
        timer,
        navTrigger = document.querySelector('[js-nav-trigger]'),
        dropdownTrigger = document.querySelector('[js-dropdown-trigger]'),
        navPanel = document.querySelector('[js-nav-panel]'),
        body = document.querySelector('body');

    if (navTrigger) {
        navTrigger.addEventListener('click', triggerNav);
        dropdownTrigger.addEventListener('click', triggerSubNav);
    }

    function triggerNav(e) {
        e.preventDefault();

        if (!menuOpened) {
            menuOpened = true;

            var isOpened = global.methods.hasAttributeValue(navTrigger, 'js-nav-trigger', 'is-active');

            global.methods.toggleAttributeValue(navTrigger, 'js-nav-trigger', 'is-active');
            global.methods.removeAttributeValue(body, 'gr-handler', 'overlay');
            global.methods.toggleAttributeValue(navPanel, 'js-nav-panel', 'is-opened');

            clearTimeout(timer);

            if (!isOpened) {
                timer = setTimeout(function() {
                    global.methods.toggleAttributeValue(body, 'gr-handler', 'overlay');
                    menuOpened = false;
                }, 600);
            }
            else {
                global.methods.removeAttributeValue(body, 'gr-handler', 'overlay');
                menuOpened = false;
            }
        }
    }

    function triggerSubNav(e) {
        e.preventDefault();
        global.methods.toggleAttributeValue(this, 'js-dropdown-trigger', 'is-opened');
    }
})(window.groots);
